module.exports = __webpack_public_path__ + "static/media/Arcade_5251.8fd457f4.jpg";